import { render, staticRenderFns } from "./CompetitionHead.vue?vue&type=template&id=551a1698&scoped=true&"
import script from "./CompetitionHead.vue?vue&type=script&lang=js&"
export * from "./CompetitionHead.vue?vue&type=script&lang=js&"
import style0 from "./CompetitionHead.vue?vue&type=style&index=0&id=551a1698&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551a1698",
  null
  
)

export default component.exports